export default __webpack_public_path__ + "static/video1-231a299e763fe817863c61429d25bba6.mp4";